import type { PublicAppConfig } from "@gerama/types";
import type { ApiClient } from "../client";

/** Public client config the admin edits under platform settings (`GET /settings/app`, not wrapped). */
export function createCoreSettingsApi(client: ApiClient) {
  return {
    app: (signal?: AbortSignal) =>
      client.request<PublicAppConfig>("/settings/app?platform=web", { signal }),
  };
}
